module.exports = __webpack_public_path__ + "static/img/1831_phase_function_Paper_Points.c3c27a5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/1831_phase_function_Paper_Points.png
// module id = 1oFI
// module chunks = 0